import * as React from "react";
import { ProfileEmailRequired } from "./ProfileEmailRequired";
import { useIsProfileMissingEmail } from "./use-is-profile-missing-email";

export const ProfileEmailRequiredContainer: React.FC = () => {
  const isProfileMissingEmail = useIsProfileMissingEmail();
  return isProfileMissingEmail ? <ProfileEmailRequired /> : <></>;
};
